<template>
  <nav>
    <v-hover
      color="accent"
      class="content-create-template"
    >
      <v-card
        slot-scope="{ hover }"
        :class="`elevation-${hover? 8 : 2 } ${hover? 'v-card--shadow': 'v-card--flat'}`"
        class="fill-height py-10"
        rounded="xxl"
        align="center"
        :disabled="productPlan.attributes && productPlan.attributes.name == 'Free' && pageImage == 'create-hub'"
      >
        <v-card-title class="text-h5 font-weight-bold text-center justify-center mb-4 no-break">
          {{ pageTitle }}
          <v-chip v-if="productPlan.attributes && productPlan.attributes.name == 'Free' && pageImage == 'create-hub'" class="rounded-lg ml-2 px-2" x-small color="accent" text-color="white">PRO</v-chip>
        </v-card-title>
        <v-card-subtitle
          class="text-body-1 darktext--text text-center d-none d-sm-block no-break mx-auto mx-xl-13"
          :style="($vuetify.breakpoint.name =='xl' || $vuetify.breakpoint.name =='lg')? 'height:75px':'height:150px'"
        >
          {{ pageText }}
        </v-card-subtitle>
        <v-card-text class="text-body-1 text-center justify-center pb-8">
          <v-img
            :src="require('../assets/' + pageImage + '.png')"
            width="100%"
            max-width="400px"
            class="mx-auto"
          />
          <!-- eslint-disable vue/no-v-html -->
        </v-card-text>
        <v-card-actions class="d-flex justify-center pb-4 pt-0">
          <v-btn
            ref="create"
            data-testid="create-button"
            color="accent"
            min-width="100"
            dark
            elevation="0"
            class="rounded-xxl text-none px-4 "
            @click="proceedSubmit"
          >
            {{ pageCreateBtn }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-hover>
  </nav>
</template>
<script>
export default {
  props: {
    pageTitle: {
      type: String,
      default: ''
    },
    pageText: {
      type: String,
      default: ''
    },
    pageImage: {
        type: String,
        default: 'empty_page'
    },
    pageCreateBtn:{
      type: String,
      default: ''
    }
  },
  computed: {
    productPlan() {
      return this.$store.state.productPlan;
    },
  },
  methods:{
        proceedSubmit(){
            this.$emit('proceedSubmit')
        }
    }
}
</script>
<style>
.content-create-template.elevation-8 { 
  box-shadow: 0px 5px 5px -3px rgb(41 98 255 / 10%),
   0px 8px 10px 1px rgb(41 98 255 / 10%),
  0px 3px 14px 2px rgb(41 98 255 / 10%) !important
}
</style>